export default __webpack_public_path__ + "static/bartekk-7928c4a31fdb3be20d183f0237e3c2e2.png";